import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Slide,
  Box,
} from "@mui/material";
import "./DiaryModal.css";
import { fetchWithAuth } from "../../../utils/fetchWithAuth";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
const API = process.env.REACT_APP_API_BASE;
const DiaryModal = ({ open, onClose, onSuccess, weddingId }) => {
  const [formData, setFormData] = useState({
    title: "",
    description: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    const body = {
      title: formData.title,
      description: formData.description,
      wedding_id: weddingId,
      checked: false,
    };

    try {
      const response = await fetchWithAuth(`${API}/todos`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        throw new Error("Failed to save todo");
      }

      onSuccess();
    } catch (error) {
      console.error("Error creating todo:", error);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      keepMounted
      className="diary-modal"
      PaperProps={{
        className: "custom-dialog-paper",
      }}
    >
      <DialogTitle className="diary-modal-title">Додади задача</DialogTitle>
      <DialogContent>
        <Box mt={1} mb={2}>
          <TextField
            name="title"
            label="Наслов"
            value={formData.title}
            onChange={handleChange}
            fullWidth
            margin="normal"
            className="diary-modal-input"
          />
          <TextField
            name="description"
            label="Опис"
            value={formData.description}
            onChange={handleChange}
            fullWidth
            margin="normal"
            multiline
            rows={3}
            className="diary-modal-input"
          />
        </Box>
      </DialogContent>
      <DialogActions className="diary-modal-actions">
        <Button
          onClick={onClose}
          variant="outlined"
          className="diary-modal-cancel"
        >
          Откажи
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          className="diary-modal-submit"
        >
          Додади
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DiaryModal;
